import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Discord() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "18",
    height: "21",
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_578_29)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M12.11 10C12.11 10.61 11.66 11.11 11.09 11.11C10.53 11.11 10.07 10.61 10.07 10C10.07 9.39 10.52 8.89 11.09 8.89C11.66 8.89 12.11 9.39 12.11 10ZM7.44 8.89C6.87 8.89 6.42 9.39 6.42 10C6.42 10.61 6.88 11.11 7.44 11.11C8.01 11.11 8.46 10.61 8.46 10C8.47 9.39 8.01 8.89 7.44 8.89ZM18 2.56V20.5C15.4807 18.2737 16.2864 19.0106 13.36 16.29L13.89 18.14H2.55C1.42 18.14 0.5 17.22 0.5 16.08V2.56C0.5 1.42 1.42 0.5 2.55 0.5H15.95C17.08 0.5 18 1.42 18 2.56ZM15.15 12.04C15.15 8.82 13.71 6.21 13.71 6.21C12.27 5.13 10.9 5.16 10.9 5.16L10.76 5.32C12.46 5.84 13.25 6.59 13.25 6.59C10.8746 5.28809 8.08422 5.28785 5.78 6.3C5.41 6.47 5.19 6.59 5.19 6.59C5.19 6.59 6.02 5.8 7.82 5.28L7.72 5.16C7.72 5.16 6.35 5.13 4.91 6.21C4.91 6.21 3.47 8.82 3.47 12.04C3.47 12.04 4.31 13.49 6.52 13.56C6.52 13.56 6.89 13.11 7.19 12.73C5.92 12.35 5.44 11.55 5.44 11.55C5.58711 11.653 5.82969 11.7864 5.85 11.8C7.53789 12.7452 9.93547 13.0549 12.09 12.15C12.44 12.02 12.83 11.83 13.24 11.56C13.24 11.56 12.74 12.38 11.43 12.75C11.73 13.13 12.09 13.56 12.09 13.56C14.3 13.49 15.15 12.04 15.15 12.04Z",
        fill: "black"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_578_29",
        children: /*#__PURE__*/_jsx("rect", {
          width: "17.5",
          height: "20",
          fill: "black",
          transform: "translate(0.5 0.5)"
        })
      })
    })]
  });
}
export default Discord;